import DateTimeFormatPart = Intl.DateTimeFormatPart;
import {Vue} from "vue-property-decorator";

const getDateParts = function (value: Date | number | string | undefined): DateTimeFormatPart[] {
    if (!value)
        return [];
    const d = new Date(value);
    const dtf = new Intl.DateTimeFormat('de', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });

    return dtf.formatToParts(d);
}

const resolveDelimters = function (str: string, dateDelimiter: string, timeDelimiter: string): string {
    return str.replace(new RegExp("delDate", "gi"), dateDelimiter)
        .replace(new RegExp("delTime", "gi"), timeDelimiter);
}

export const formatDateTime = function (value: Date | number | string | undefined, dateDelimiter?: string, timeDelimiter?: string, omitSeconds?: boolean): string {
    if (!value)
        return "";
    const [{value: da}, , {value: mo}, , {value: ye}, , {value: ho}, , {value: mi}, , {value: sec}] = getDateParts(value);
    return resolveDelimters(`${da}delDate${mo}delDate${ye} ${ho}delTime${mi}${omitSeconds ? "" : "delTime"}${omitSeconds ? "" : sec}`, dateDelimiter ?? ".", timeDelimiter ?? ":");
}

export const formatDate = function (value: Date | number | string | undefined, dateDelimiter?: string): string {
    if (!value)
        return "";
    const [{value: da}, , {value: mo}, , {value: ye}] = getDateParts(value);
    return resolveDelimters(`${da}delDate${mo}delDate${ye}`, dateDelimiter ?? ".", "");
}

export const formatTime = function (value: Date | number | string | undefined, timeDelimiter?: string, omitSeconds?: boolean): string {
    if (!value)
        return "";
    const [, , , , , , {value: ho}, , {value: mi}, , {value: sec}] = getDateParts(value);
    return resolveDelimters(`${ho}delTime${mi}${omitSeconds ? "" : "delTime"}${omitSeconds ? "" : sec}`, "", timeDelimiter ?? ":");
}

export const formatDateTimeFilter = Vue.filter('formatDateTime', formatDateTime);
export const formatDateFilter = Vue.filter('formatDate', formatDate);
export const formatTimeFilter = Vue.filter('formatTime', formatTime);

export const dateFromMedicalDate = function(fieldValues: any): Date {
    if (fieldValues == undefined || fieldValues.value == undefined ||
        fieldValues.value == "ongoing" || fieldValues.value == "unknown")
        return new Date();

    let year = fieldValues?.year;
    if (year == undefined || year == "XXXX")
        return new Date();

    let month = fieldValues?.month;
    let day = fieldValues?.day;
    if (month == undefined || month == "XX" || month == "UK")
        month = "01";
    if (day == undefined || day == "XX" || day == "UK")
        day = "01";
    return new Date(year + "-" + month + "-" + day);
}
